// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_HmI","cls2":"DebugPage-cls2_KVv DebugPage-cls1_HmI"};